import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDAliKWpReYZgBXldxVCw_wP5nN_WQVnuI",
  authDomain: "opportunai.firebaseapp.com",
  projectId: "opportunai",
  storageBucket: "opportunai.appspot.com",
  messagingSenderId: "166880731473",
  appId: "1:166880731473:web:e8e50ae98be4c588a1f370",
  measurementId: "G-6V91LMY0DJ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Auth with session timeout
const auth = getAuth(app);

// Initialize Firestore with simplified settings
const db = getFirestore(app);

// Initialize Storage
const storage = getStorage(app);

// Initialize Analytics
const analytics = getAnalytics(app);

export { auth, db, storage, analytics };